import { TextField } from "components/form";
import { Field, FieldArray } from "formik";

export default function MetaDataComponent({ values, setFieldValue, type }) {
  return (
    <div className="w-full mt-20">
      <FieldArray name="metaData">
        {({ push: addMetaData, remove: removeMetaData }) => (
          <div>
            <div className="flex items-center justify-between mb-6">
              <h4 className="font-bold text-lg mb-4">متادیتا(دیتا اضافی)</h4>
              <button
                type="button"
                onClick={() => {
                  addMetaData({
                    entityType: type,
                    entity: values?.id,
                    translations: {
                      fa: {
                        key: "",
                        value: "",
                        description: "",
                      },
                      en: {
                        key: "",
                        value: "",
                        description: "",
                      },
                    },
                  });
                }}
                className="mb-4 px-4 py-2 bg-green-500 text-white rounded shadow hover:bg-green-600"
              >
                افزودن متادیتا
              </button>
            </div>

            {values.metaData?.map((metaData, idx) => (
              <div key={idx} className="mb-6 border p-4 rounded shadow">
                <div className="mb-4">
                  <div className="intro-x grid md:grid-cols-2 md:gap-3">
                    <Field
                      placeholder="کلید"
                      label="کلید :"
                      name={`metaData[${idx}]translations.fa.key`}
                      component={TextField}
                    />

                    <Field
                      placeholder="کلید(en)"
                      label="کلید(en) :"
                      name={`metaData[${idx}]translations.en.key`}
                      component={TextField}
                    />
                  </div>

                  <div className="intro-x grid md:grid-cols-2 md:gap-3">
                    <Field
                      placeholder="مقدار"
                      label="مقدار :"
                      name={`metaData[${idx}]translations.fa.value`}
                      component={TextField}
                    />

                    <Field
                      placeholder="مقدار(en)"
                      label="مقدار(en) :"
                      name={`metaData[${idx}]translations.en.value`}
                      component={TextField}
                    />
                  </div>
                  <div className="intro-x grid md:grid-cols-2 md:gap-3">
                    <Field
                      placeholder="توضیحات"
                      label="توضیحات :"
                      name={`metaData[${idx}]translations.fa.description`}
                      component={TextField}
                    />

                    <Field
                      placeholder="توضیحات(en)"
                      label="توضیحات(en) :"
                      name={`metaData[${idx}]translations.en.description`}
                      component={TextField}
                    />
                  </div>
                </div>

                <button
                  type="button"
                  onClick={() => {
                    setFieldValue("deleteMetaData", [
                      ...(values?.deleteMetaData || []),
                      values?.metaData[idx]?.id,
                    ]);
                    removeMetaData(idx);
                  }}
                  className="px-3 py-2 bg-red-500 text-white rounded shadow hover:bg-red-600"
                >
                  حذف متادیتا
                </button>
              </div>
            ))}
          </div>
        )}
      </FieldArray>
    </div>
  );
}
